var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78892 3.10595C9.05206 1.63136 6.94807 1.63135 6.2112 3.10593L2.21355 11.1058C1.54901 12.4356 2.51593 14 4.00241 14H11.9976C13.4841 14 14.451 12.4356 13.7865 11.1058L9.78892 3.10595ZM7.33335 5.99967C7.33335 5.63147 7.6318 5.33298 7.99996 5.33298C8.36811 5.33298 8.66657 5.63147 8.66657 5.99967V8.66645C8.66657 9.03465 8.36811 9.33314 7.99996 9.33314C7.6318 9.33314 7.33335 9.03465 7.33335 8.66645V5.99967ZM7.33335 10.6665C7.33335 10.2983 7.6318 9.99984 7.99996 9.99984C8.36811 9.99984 8.66657 10.2983 8.66657 10.6665C8.66657 11.0347 8.36811 11.3332 7.99996 11.3332C7.6318 11.3332 7.33335 11.0347 7.33335 10.6665Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.48a32cd1.svg";
export { ForwardRef as ReactComponent };